import { BreakSchedulesPage } from "@/pages/configuration/break-schedules";
import CatalogCategories from "@/pages/configuration/delay-categories";
import { CatalogCustomersPage } from "@/pages/configuration/customers";
import { CatalogGradesPage } from "@/pages/configuration/grades";
import { CatalogKeepersPage } from "@/pages/configuration/keepers";
import { CatalogPaintCutTypesPage } from "@/pages/configuration/paint-cut-types";
import { CatalogSectionsPage } from "@/pages/configuration/sections";
import AlarmIcon from "@mui/icons-material/Alarm";
import BuildIcon from "@mui/icons-material/Build";
import CategoryIcon from "@mui/icons-material/Category";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import GridViewIcon from "@mui/icons-material/GridView";
import PeopleIcon from "@mui/icons-material/People";
import StarIcon from "@mui/icons-material/Star";
import TimelineIcon from "@mui/icons-material/Timeline";
import {
	List,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	useTheme,
} from "@mui/material";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import CatalogDelayCodes from "../pages/configuration/delay-codes";

type Component = {
	path: string;
	sidebar: () => ReactNode;
	main: () => ReactNode;
};

const components: Component[] = [
	{
		path: "delay-categories",
		sidebar: () => <div>Categories</div>,
		main: () => <CatalogCategories />,
	},
	{
		path: "delay-codes",
		sidebar: () => <div>Codes</div>,
		main: () => <CatalogDelayCodes delayAreaAssetName="DefaultAreaId" />,
	},
	{
		path: "sections",
		sidebar: () => <div>Sections</div>,
		main: () => <CatalogSectionsPage />,
	},
	{
		path: "customers",
		sidebar: () => <div>Customers</div>,
		main: () => <CatalogCustomersPage />,
	},
	{
		path: "grades",
		sidebar: () => <div>Grades</div>,
		main: () => <CatalogGradesPage />,
	},
	{
		path: "keepers",
		sidebar: () => <div>Keepers</div>,
		main: () => <CatalogKeepersPage />,
	},
	{
		path: "paint-cut-types",
		sidebar: () => <div>Paint Cut Types</div>,
		main: () => <CatalogPaintCutTypesPage />,
	},
	{
		path: "break-schedules",
		sidebar: () => <div>Break Schedules</div>,
		main: () => <BreakSchedulesPage />,
	},
];

const sidebar = ({ option }: { option?: string }) => {
	const theme = useTheme();

	return (
		<>
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Delays
					</ListSubheader>
				}
			>
				<ListItemButton
					selected={option === "categories"}
					component={Link}
					to="/configuration/delay-categories"
				>
					<ListItemIcon>
						<CategoryIcon />
					</ListItemIcon>
					<ListItemText primary="Categories" />
				</ListItemButton>
				<ListItemButton
					selected={option === "codes"}
					component={Link}
					to="/configuration/delay-codes"
				>
					<ListItemIcon>
						<TimelineIcon />
					</ListItemIcon>
					<ListItemText primary="Codes" />
				</ListItemButton>
			</List>
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Steel
					</ListSubheader>
				}
			>
				<ListItemButton
					selected={option === "sections"}
					component={Link}
					to="/configuration/sections"
				>
					<ListItemIcon>
						<GridViewIcon />
					</ListItemIcon>
					<ListItemText primary="Sections" />
				</ListItemButton>
				<ListItemButton
					selected={option === "customers"}
					component={Link}
					to="/configuration/customers"
				>
					<ListItemIcon>
						<PeopleIcon />
					</ListItemIcon>
					<ListItemText primary="Customers" />
				</ListItemButton>
				<ListItemButton
					selected={option === "grades"}
					component={Link}
					to="/configuration/grades"
				>
					<ListItemIcon>
						<StarIcon />
					</ListItemIcon>
					<ListItemText primary="Grades" />
				</ListItemButton>
			</List>
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Fabrication
					</ListSubheader>
				}
			>
				<ListItemButton
					selected={option === "keepers"}
					component={Link}
					to="/configuration/keepers"
				>
					<ListItemIcon>
						<BuildIcon />
					</ListItemIcon>
					<ListItemText primary="Keepers" />
				</ListItemButton>
				<ListItemButton
					selected={option === "paint-cut-types"}
					component={Link}
					to="/configuration/paint-cut-types"
				>
					<ListItemIcon>
						<ContentCutIcon />
					</ListItemIcon>
					<ListItemText primary="Paint Cut Types" />
				</ListItemButton>
			</List>
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Shifts
					</ListSubheader>
				}
			>
				<ListItemButton
					selected={option === "break-schedules"}
					component={Link}
					to="/configuration/break-schedules"
				>
					<ListItemIcon>
						<AlarmIcon />
					</ListItemIcon>
					<ListItemText primary="Break Schedules" />
				</ListItemButton>
			</List>
		</>
	);
};

const customConfigurations: any = [components, sidebar];

export { customConfigurations };
